/* VPV Native Slider — shared native horizontal scroller (NOT Flickity). The
   host element decides WHEN it's a scroller (CSS: e.g. a flex/overflow row only
   at mobile) and how wide the cards are; this just drives the progress bar from
   native scrollLeft and hides it when nothing overflows. Adds desktop click-drag
   (touch uses native momentum). Hooks:
     [data-vpv-nslider]        the root
     [data-vpv-nslider-track]  the scrolling element (its children are the cards)
     [data-vpv-nslider-bar]    the progress fill (optional); its parent is the
                               progress track, hidden when there's no overflow */
(function () {
  function init(root) {
    if (root.dataset.vpvNsliderInit) return;
    root.dataset.vpvNsliderInit = '1';

    var track = root.querySelector('[data-vpv-nslider-track]');
    if (!track) return;
    var bar = root.querySelector('[data-vpv-nslider-bar]');
    var progress = bar ? bar.parentElement : null;

    function update() {
      var sw = track.scrollWidth;
      var cw = track.clientWidth;
      var overflows = sw - cw > 1;
      if (progress) progress.hidden = !overflows;
      // Deterministic overflow fallback for center-aligned tracks: `safe center`
      // is supposed to fall back to start-alignment on overflow, but iOS 17 Safari
      // doesn't honor it, leaving the cards centered so the first/last get clipped
      // (and the first becomes unreachable). Flag overflow here; CSS forces
      // start-alignment on .is-overflowing.
      track.classList.toggle('is-overflowing', overflows);
      if (overflows && bar) {
        bar.style.width = (Math.min(1, (track.scrollLeft + cw) / sw) * 100) + '%';
      }
    }

    track.addEventListener('scroll', update, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    update();

    // Desktop click-drag to scroll (touch uses native momentum scrolling).
    var down = false, startX = 0, startScroll = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });
    window.addEventListener('pointerup', function () {
      down = false;
      track.classList.remove('is-dragging');
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vpv-nslider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
